export class PaginateResponseModel<T> {
	code: number;
	contentLength: number;
	data: Array<T>;
	count: number;
}
